import { ApolloClient, TypedDocumentNode } from '@apollo/client';

export const readFromCachedFragment = (client: ApolloClient<any>, id: string, fragment: TypedDocumentNode) =>
  client.readFragment({
    id,
    fragment,
  });
